var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPen = function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2007 2.37235L12.5045 0L16.0641 3.45443L13.7604 5.8279L10.2007 2.37235ZM2.42263 10.3827L5.98228 13.8383L12.8384 6.77616L9.27895 3.32174L2.42263 10.3827ZM5.06277 14.7865L1.50296 11.3308L0 16.2037L5.06277 14.7865Z",
    fill: "#E0E0E0"
  })));
};
export default SvgPen;